export interface IClaim {
  schedule_id: number;
  reason: string;
  logged_date: Date;
}
export interface IClaimNumber {
  email: string;
  number: string;
  provider: string;
}
export interface IClaimCategories {
  all_risks: Array<string>;
  buildings: Array<string>;
  caravans: Array<string>;
  contents: Array<string>;
  motorcycles: Array<string>;
  specified_items: Array<string>;
  vehicles: Array<string>;
}

export interface IClaimsReason {
  asset_id?: number;
  created_time?: string;
  date_full?: string;
  id: number;
  modified_time?: string;
  reason: string;
  user_id?: number;
}
